import { GatsbyBackgroundImage } from "@theme/components";

import { strapiImageResolver } from "@theme/utils";

import type { ThemeUIStyleObject } from "@theme/components";
import type { StrapiBackgroundImagesInterface } from "@theme/types";
import type { CSSProperties, FC } from "react";

interface StrapiBackgroundImageProps {
  images: StrapiBackgroundImagesInterface;
  loading?: "lazy" | "eager";
  alt?: string;
  sx?: ThemeUIStyleObject;
  style?: CSSProperties;
  imgStyle?: CSSProperties;
  className?: string;
}

/**
 * Strapi Background Image
 *
 * This component takes our StrapiBackgroundImagesInterface and renders a GatsbyBackgroundImage
 * under the hood. cleans up the code to isolate the resolvers
 */
export const StrapiBackgroundImage: FC<StrapiBackgroundImageProps> = ({
  images,
  loading,
  alt,
  sx,
  style,
  imgStyle,
  className,
}) => {
  const image480 = strapiImageResolver(images.image480).childImageSharp.gatsbyImageData;
  const image768 = images.image768
    ? strapiImageResolver(images.image768).childImageSharp.gatsbyImageData
    : null;
  const image1024 = images.image1024
    ? strapiImageResolver(images.image1024).childImageSharp.gatsbyImageData
    : null;
  const image1366 = images.image1366
    ? strapiImageResolver(images.image1366).childImageSharp.gatsbyImageData
    : null;
  const image2560 = images.image2560
    ? strapiImageResolver(images.image2560).childImageSharp.gatsbyImageData
    : null;

  return (
    <GatsbyBackgroundImage
      className={className}
      alt={alt}
      loading={loading}
      images={[image480, image768, image1024, image1366, image2560]}
      sx={{ ...sx }}
      style={style}
      imgStyle={imgStyle}
    />
  );
};
